import React, { useContext } from 'react';

import { makeStyles } from '@gogame/components';

import AuthContext from './AuthContext';
import { MultiProviderWidget } from './MultiProvider';
import { OktaSignInWidget } from './providers/Okta';

const useStyles = makeStyles(() => ({
  AuthForm: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
export const AuthForm = () => {
  const classes = useStyles();
  const { login, isPartner, hasError } = useContext(AuthContext);

  return (
    <div className={classes.AuthForm}>
      {React.createElement(isPartner ? MultiProviderWidget : OktaSignInWidget, {
        onLogin: login,
        hasError,
      })}
    </div>
  );
};
